// import store from '@/store'
import resize from '@utils/resize'
export default {
  beforeMount () {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted () {
    this.$_resizeHandler()
  },
  methods: {
    $_resizeHandler () {
      resize.init()
    }
  }
}
